var React = require('react');

function VrCardboard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M608 64H32A32 32 0 0 0 0 96v320a32 32 0 0 0 32 32h160.22a64 64 0 0 0 58.36-37.74l27.74-61.64c7.89-17.54 24-28.62 41.68-28.62s33.79 11.08 41.68 28.62l27.74 61.64A64 64 0 0 0 447.78 448H608a32 32 0 0 0 32-32V96a32 32 0 0 0-32-32zM160 304a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm320 0a64 64 0 1 1 64-64 64 64 0 0 1-64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 176a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm320 0a64 64 0 1 0 64 64 64 64 0 0 0-64-64z","className":"fa-primary","key":2})]);
}

VrCardboard.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = VrCardboard;

VrCardboard.default = VrCardboard;
